export default __webpack_public_path__ + "static/media/131.d5712d64.gif";